import { useSignal } from "@preact/signals-react"
import { analyzerChartVisibility } from "Pages/AnalyzersV2/@signals"
import { chartRows, chartSeries } from "Pages/AnalyzersV2/@services/chartView"

// Series and rows come from the props on every render (CU-869fmm949): an answer that arrives without remounting the
// chart (Min / Max, the Cars selector) is painted with its own series and prices, not with those of the first one.
export default function useAnalyzerChart(keySeries, chartData) {
	const showByPrice = useSignal('price')
	const isLoading = useSignal(false)
	const isVisible = useSignal(true)
	const seriesDiff = chartSeries(keySeries, 'diff')
	const seriesToApply = chartSeries(keySeries, showByPrice.value)
	// the site picked in the chart's own filter (Rating): `{ value, label }`, or null for all
	const siteFilter = useSignal(null)
	const filteredChart = chartRows(chartData, siteFilter.value?.label)
	const showChartInFullScreen = useSignal(false)

	const toggleFullScreen = () => {
		showChartInFullScreen.value = !showChartInFullScreen.value
	}

	const onChangeShowPrice = value => {
		showByPrice.value = value
		analyzerChartVisibility.value = chartSeries(keySeries, value).map(({ dataKey }) => dataKey)
	}

	const onFilterSites = option => {
		const { value, label } = option || {}
		siteFilter.value = value ? { value, label } : null
	}


	const handleIsLoading = value => {
		isLoading.value = value
	}

	const titleChart = () => {
		const url = window.location.pathname
		if (url.includes('direct-site')) {
			return "Sites"
		} else if (url.includes('brokers')) {
			return "Brokers"
		} else if (url.includes('lor')) {
			return "Length of Rental"
		} else if (url.includes('dor')) {
			return "Dates of Rental"
		}
		return "Rating"
	}

	const setIsVisible = () => {
		if (isVisible.value || !!analyzerChartVisibility.value.length) {
			analyzerChartVisibility.value = []
			isVisible.value = false
		} else {
			analyzerChartVisibility.value = seriesToApply.map(({ dataKey }) => dataKey)
			isVisible.value = true
		}
	}

	const onLegendClick = e => {
		const value = e.target.dataItem._settings.name
		const idx = analyzerChartVisibility.value.findIndex(name => name === value)

		if (idx !== -1) {
			analyzerChartVisibility.value.splice(idx, 1)
		} else {
			analyzerChartVisibility.value.push(value)
		}
	}

	return {
		setIsVisible,
		onLegendClick,
		showByPrice: showByPrice.value,
		onChangeShowPrice,
		handleIsLoading,
		filteredChart,
		isLoading: isLoading.value,
		titleChart: titleChart(),
		hasSeriesDiff: !!seriesDiff.length,
		seriesToApply,
		onFilterSites,
		sitesSelected: siteFilter.value?.value ?? null,
		toggleFullScreen,
		showChartInFullScreen: showChartInFullScreen.value,
	}
}
